var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FilterSearch } from 'app/models/support.model';
import { SupportService } from './support.service';
import { ModalService } from 'app/views/modal/base_modal.component';
import { TranslateService } from 'app/translate/translate.service';
import { LogsModalComponent } from './modals/logs.component';
import { SetPremiumTemplatesModalComponent } from './modals/set_premium_templates.component';
import { SetProModalComponent } from './modals/set_pro.component';
import { RestorePasswordModalComponent } from './modals/restore_password.component';
import { SetPasswordModalComponent } from './modals/set_password.component';
import { SetRoleModalComponent } from './modals/set_role.component';
import { SetUserBanModalComponent } from './modals/set_user_ban.component';
import { SetUnBanModalComponent } from './modals/set_unban.component';
import { RenewTrialModalComponent } from './modals/renew_trial.component';
import { SetSiteBlockModalComponent } from './modals/set_site_block.component';
import { SetSiteUnBlockModalComponent } from './modals/set_site_unblock.component';
import { AttachTariffModalComponent } from './modals/attach_tariff.component';
import { ChangeOwnerModalComponent } from './modals/change_owner.component';
import { ChangeTariffModalComponent } from './modals/change_tariff.component';
import { TransferInvoiceModalComponent } from './modals/transfer_invoice.component';
import { RemoveInvoiceModalComponent } from './modals/remove_invoice.component';
import { EditSiteModalComponent } from './modals/edit_site.component';
import { RenewTariffModalComponent } from './modals/renew_tariff.component';
import { RemoveSiteModalComponent } from './modals/remove_site.component';
import { ChangeLangModalComponent } from './modals/change_lang.component';
import { BreakPublishModalComponent } from './modals/break_publish.component';
import { SeoUberModalComponent } from 'app/support/support/modals/seo_uber.component';
import { SetFreemiumUserModalComponent } from './modals/set_freemium_user.component';
import { SetFreemiumSiteModalComponent } from './modals/set_freemium_site.component';
import { SetUberTariffModalComponent } from './modals/set_uber_tariff.component';
import { SetDivlyIdModalComponent } from './modals/set_divly_id.component';
import { SetExcludeFromStatsComponent } from './modals/set_exclude_from_stats';
import { ActivatedRoute, Router } from '@angular/router';
import * as qs from 'qs';
import { getUtmList, getUTMhash, getSiteStatusStyle } from 'app/lib/lib';
import { PaidDetailsComponent } from 'app/views/modal/paid_details/paid_details.component';
import { ConfirmComponent } from '../../views/modal/confirm.component';
import { BanSitesByListModalComponent } from './modals/ban_sites_by_list.component';
import { CheckForDivlyModalComponent } from './modals/check_for_divly.component';
import { DateFormat } from '../../pipes/dateFormat.pipe';
import { RestoreSiteModalComponent } from './modals/restore_site.component';
import { EditRecurrentModalComponent } from './modals/edit_recurrent.component';
import { SetDivlyLabelModalComponent } from './modals/set_divly_label.component';
import { DisableRecurrentModalComponent } from './modals/disable_recurrent.component';
import { UserReRegInfoModalComponent } from './modals/rereg_modal.component';
import { ChangeCurrencyModalComponent } from "./modals/change_currency.component";
import { SiteHistoryModal } from "./modals/site_history_modal.component";
import { SetMultilangCloneModalComponent } from "./modals/set_multilang_clone.component";
import { CloneSiteModalComponent } from './modals/clone_site.component';
import { FixWidgetsModalComponent } from './modals/fix-widgets.component';
import { SiteFilesModalComponent } from './modals/site_files.component';
import { ReturnPaidComponent } from './modals/return_paid';
import { AlertComponent } from '../../views/modal/alert.component';
import { SitesService } from '../../sites/sites.service';
import { catchError, map, switchMap, tap, toArray, concatMap } from 'rxjs/operators';
import { from, of } from "rxjs";
import { EventsService } from '../../lib/EventsService';
import { PromptComponent } from "../../views/modal/prompt.component";
import { NotificationsService } from "angular2-notifications";
import { HelperService } from "../../lib/helper.service";
import { BillingService2 } from "../../billing/billing.service";
import { DataProvider2 } from "../../provider/data2.provider";
import { PromoputlModalComponent } from "./modals/promoputl.component";
import { AuthService } from "../../auth.service";
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    return SearchResult;
}());
var SupportComponent = /** @class */ (function () {
    function SupportComponent(supportService, activatedRoute, router, translate, modalService, datePipe, siteService, eventsService, notificationService, helperService, billingService, dp2, authService) {
        this.supportService = supportService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.translate = translate;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this.siteService = siteService;
        this.eventsService = eventsService;
        this.notificationService = notificationService;
        this.helperService = helperService;
        this.billingService = billingService;
        this.dp2 = dp2;
        this.authService = authService;
        this.filters = ['site', 'email', 'username', 'invoiceNumber'];
        this.filterSearch = new FilterSearch();
        this.typeFilter = 'email';
        this.searchInProgress = false;
        this.userInProgress = false;
        this.sitesInProgress = false;
        this.r = 456;
        this.searchResult = new SearchResult();
        this.user = null;
        this.sites = [];
        this.apps = [];
        this.utmList = getUtmList();
        this.billingButtons = {
            ctfs: {
                text: 'support.support.change tariff',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['paid']
                },
                class: 'primary'
            },
            rifs: {
                text: 'support.support.extend tariff',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['paid']
                },
                class: 'info'
            },
            rtfs: {
                text: 'support.support.extend trial',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['trial', 'trialExpired', 'paidExpired']
                },
                class: 'primary'
            },
            atts: {
                text: 'support.support.apply tariff',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['trial', 'trialExpired', 'paidExpired']
                },
                class: 'success'
            },
            mits: {
                text: 'support.support.transfer payment',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['paid']
                },
                class: 'warning'
            },
            rsai: {
                text: 'support.support.disable tariff',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['paid']
                },
                class: 'danger'
            },
            return_paid: {
                text: 'support.support.return paid',
                condition: {
                    value: 'sitePaidStatus',
                    equals: ['paid']
                },
                class: 'danger'
            }
        };
        this.isCollapsedButtonNote = true;
        this.isCollapsedButtonsMore = [];
        this.isCollapsedSiteMap = [];
        this.paidStatuses = {
            trialExpired: { i18n: this.translate.__A('support.support.trialExpired'), label: 'danger' },
            trial: { i18n: this.translate.__A('support.support.trial'), label: 'info' },
            paidExpired: { i18n: this.translate.__A('support.support.paidExpired'), label: 'danger' },
            paid: { i18n: this.translate.__A('support.support.paid'), label: 'success' },
            municipal: { i18n: 'Муниципальный', label: 'info' },
            promo: { i18n: 'Промо', label: 'info' },
        };
        this.getUTMhash = getUTMhash;
        this.getSiteStatusStyle = getSiteStatusStyle;
        this.sitePageSize = 10;
        this.sitesOnPage = 0;
    }
    Object.defineProperty(SupportComponent.prototype, "billingButtonsActions", {
        get: function () {
            return Object.keys(this.billingButtons);
        },
        enumerable: true,
        configurable: true
    });
    SupportComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            var _this = this;
            return __generator(this, function (_a) {
                me = this;
                Object.keys(me.billingButtons).forEach(function (k) {
                    me.billingButtons[k].text = me.translate.__A(me.billingButtons[k].text);
                });
                me.activatedRoute.queryParams.subscribe(function (params) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(Object.keys(params).length > 0)) return [3 /*break*/, 2];
                                if (params.typeFilter) {
                                    me.typeFilter = params.typeFilter;
                                }
                                if (params.value) {
                                    me.filterSearch[me.typeFilter] = params.value;
                                }
                                if (params.accurateSiteSearch) {
                                    me.filterSearch.accurateSiteSearch = params.accurateSiteSearch == 'true';
                                }
                                if (params.r) {
                                    me.r = params.r;
                                }
                                if (params.cluster) {
                                    me.supportService.cluster = parseInt(params.cluster, 10);
                                }
                                return [4 /*yield*/, me.getData()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(SupportComponent.prototype, "totalSiteCount", {
        get: function () {
            return this.searchResult.siteIdList.length;
        },
        enumerable: true,
        configurable: true
    });
    SupportComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                me = this;
                if (!me.filterSearch[me.typeFilter]) {
                    return [2 /*return*/];
                }
                if (me.$s) {
                    me.$s.unsubscribe();
                    me.$s = null;
                }
                me.$s = of({
                    value: me.filterSearch[me.typeFilter],
                    typeFilter: me.typeFilter,
                    accurateSiteSearch: me.filterSearch.accurateSiteSearch,
                    sitePage: me.filterSearch.sitePage,
                })
                    .pipe(tap(function () {
                    me.clearData();
                    me.searchInProgress = true;
                }), switchMap(function (_a) {
                    var value = _a.value, typeFilter = _a.typeFilter, accurateSiteSearch = _a.accurateSiteSearch;
                    return me.supportService.getSearchResult(value, typeFilter, accurateSiteSearch);
                }), tap(function () { return me.searchInProgress = false; }), map(function (data) {
                    if (!data) {
                        throw new Error('not found');
                    }
                    me.searchResult.userId = data['userId'];
                    me.searchResult.siteIdList = data['siteIdList'];
                }), tap(function () { return me.userInProgress = true; }), switchMap(function () { return me.supportService.getUserInfoByID(me.searchResult.userId); }), tap(function () { return me.userInProgress = false; }), map(function (userInfo) {
                    me.user = userInfo.user;
                    me.isCollapsedButtonNote = !(me.user.note !== '');
                    me.apps = userInfo['appDataList'];
                }), switchMap(function () { return me.fillSites(me.filterSearch.sitePage, me.sitePageSize); }), catchError(function (err) {
                    me.clearData();
                    me.eventsService.broadcast('http-error', err);
                    return of(err);
                }))
                    .subscribe(function () { return console.log('support load end'); });
                return [2 /*return*/];
            });
        });
    };
    SupportComponent.prototype.clearData = function () {
        var me = this;
        me.searchInProgress = false;
        me.userInProgress = false;
        me.sitesInProgress = false;
        me.user = null;
        me.sites = [];
        me.isCollapsedButtonsMore = [];
        me.isCollapsedSiteMap = [];
        me.apps = [];
    };
    SupportComponent.prototype.applyFilter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.r++;
                        params = {
                            value: encodeURIComponent(this.filterSearch[this.typeFilter]),
                            typeFilter: this.typeFilter,
                            accurateSiteSearch: this.filterSearch.accurateSiteSearch,
                            r: this.r,
                            cluster: this.supportService.cluster
                        };
                        params = qs.stringify(params, { encode: false });
                        return [4 /*yield*/, this.router.navigateByUrl("/support?" + params, { relativeTo: this.activatedRoute })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SupportComponent.prototype.resetFilter = function () {
        this.filterSearch = new FilterSearch();
    };
    SupportComponent.prototype.setCluster = function (cluster) {
        this.supportService.cluster = cluster;
    };
    SupportComponent.prototype.runUserAction = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var me, userId, detail, modal, logs, data, modal, logs, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        userId = this.user._id;
                        if (!(action === 'sptu')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.supportService.getSptuDetail(userId).toPromise()];
                    case 1:
                        detail = _a.sent();
                        this.modalService.open(SetPremiumTemplatesModalComponent, {
                            title: this.user.email || this.user.username,
                            userId: userId,
                            templates: detail['premiumTemplates'],
                            userTemplates: detail['userPremiumTemplates']
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 2:
                        if (!(action === 'spu')) return [3 /*break*/, 3];
                        this.modalService.open(SetProModalComponent, {
                            userId: userId,
                            title: this.user.email || this.user.username,
                            pro: this.user.pro
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 3:
                        if (!(action === 'rup')) return [3 /*break*/, 4];
                        this.modalService.open(RestorePasswordModalComponent, {
                            userId: userId,
                            title: this.user.email || this.user.username
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 4:
                        if (!(action === 'sup')) return [3 /*break*/, 5];
                        this.modalService.open(SetPasswordModalComponent, {
                            userId: userId,
                            title: this.user.email || this.user.username
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 5:
                        if (!(action === 'setUserRole')) return [3 /*break*/, 6];
                        this.modalService.open(SetRoleModalComponent, {
                            userId: userId,
                            title: this.user.email || this.user.username,
                            role: this.user.role,
                            accessor: this.user.accessor,
                            admin: this.user.admin
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 6:
                        if (!(action === 'userBan' || action === 'userUnBan')) return [3 /*break*/, 7];
                        if (this.user.isBan) {
                            this.modalService.open(SetUnBanModalComponent, {
                                userId: userId,
                                title: this.user.email || this.user.username,
                                email: this.user.email
                            }).result.then(function (result) {
                                if (result === 'OK') {
                                    me.applyFilter();
                                }
                            });
                        }
                        else {
                            this.modalService.open(SetUserBanModalComponent, {
                                userId: userId,
                                title: this.user.email || this.user.username,
                                email: this.user.email
                            }).result.then(function (result) {
                                if (result === 'OK') {
                                    me.applyFilter();
                                }
                            });
                        }
                        return [3 /*break*/, 14];
                    case 7:
                        if (!(action === 'sfu')) return [3 /*break*/, 8];
                        this.modalService.open(SetFreemiumUserModalComponent, {
                            userId: userId,
                            title: this.user.email || this.user.username,
                            allowFreemium: this.user.allowFreemium
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 8:
                        if (!(action === 'setDivlyId')) return [3 /*break*/, 9];
                        this.modalService.open(SetDivlyIdModalComponent, {
                            title: this.user.email || this.user.username,
                            userId: userId,
                            divlyId: ''
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 14];
                    case 9:
                        if (!(action === 'showSupportLogs')) return [3 /*break*/, 11];
                        modal = this.modalService.openEmpty(LogsModalComponent, { size: 'hg' });
                        return [4 /*yield*/, this.supportService.getLogs(userId, '').toPromise()];
                    case 10:
                        logs = _a.sent();
                        data = {
                            title: 'Support logs',
                            stats: logs,
                            type: 'user'
                        };
                        this.modalService.fillData(modal, data).result.then(function () { });
                        return [3 /*break*/, 14];
                    case 11:
                        if (!(action === 'showSupportActionLogs')) return [3 /*break*/, 13];
                        modal = this.modalService.openEmpty(LogsModalComponent, { size: 'hg' });
                        return [4 /*yield*/, this.supportService.getSupportActionLogs(userId, '').toPromise()];
                    case 12:
                        logs = _a.sent();
                        data = {
                            title: 'Support Action logs',
                            stats: logs,
                            type: 'user'
                        };
                        this.modalService.fillData(modal, data).result.then(function () { });
                        return [3 /*break*/, 14];
                    case 13:
                        if (action === 'changeCurrency') {
                            this.modalService.open(ChangeCurrencyModalComponent, {
                                userId: userId,
                                title: this.user.email || this.user.username,
                                oldCurrency: this.user.currency
                            }).result.then(function (result) {
                                if (result === 'OK') {
                                    me.applyFilter();
                                }
                            });
                        }
                        else if (action === 'exclude_from_stats') {
                            this.modalService.open(SetExcludeFromStatsComponent, {
                                userId: userId,
                                title: this.user.email || this.user.username,
                            }).result.then(function (result) {
                                if (result === 'OK') {
                                    me.applyFilter();
                                }
                            });
                        }
                        _a.label = 14;
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    SupportComponent.prototype.runSiteAction = function (action, siteId) {
        return __awaiter(this, void 0, void 0, function () {
            var me, site, result, result, result, result, modal, details, data, modal, details, data, _a, _b, modal, details, data, modal, details, data, modal, details, data, modal, details, categories, data, modal, stats, data, modal, stats, data, modal, details, data, result, result, result, transactions_1, modal, form_1, modal, stats, data, modal, details, siblings, sites, data, result, result;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        me = this;
                        site = this.sites.find(function (s) { return s._id === siteId; });
                        if (!(action === 'rtfs')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.modalService.open(RenewTrialModalComponent, {
                                siteId: site._id,
                                title: site.domainUrl,
                                trialExpiration: site._trialExpiration ? site._trialExpiration : 0,
                                dateTrialStart: this.datePipe.transform(site.dateTrialStart, 'YYYY-MM-DD')
                            }).result];
                    case 1:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 2:
                        if (!(action === 'siteBlock' || action === 'siteUnBlock')) return [3 /*break*/, 7];
                        if (!site.isBlock) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.modalService.open(SetSiteUnBlockModalComponent, {
                                siteId: site._id,
                                title: site.domainUrl,
                                domainUrl: site.domainUrl,
                                userEmail: this.user.email
                            }).result];
                    case 3:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.modalService.open(SetSiteBlockModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            userEmail: this.user.email
                        }).result];
                    case 5:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        _c.label = 6;
                    case 6: return [3 /*break*/, 54];
                    case 7:
                        if (!(action === 'atts')) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.modalService.open(AttachTariffModalComponent, {
                                siteId: site._id,
                                title: site.domainUrl,
                                domainUrl: site.domainUrl,
                                notFirstPayment: (site.paidType === 'paid')
                            }).result];
                    case 8:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 9:
                        if (!(action === 'chso')) return [3 /*break*/, 11];
                        modal = this.modalService.openEmpty(ChangeOwnerModalComponent);
                        return [4 /*yield*/, this.supportService.getChsoDetail(siteId).toPromise()];
                    case 10:
                        details = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            oldOwnerEmail: this.user.email,
                            domains: details.domains,
                            emails: details.emails,
                        };
                        this.modalService.fillData(modal, data).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 11:
                        if (!(action === 'ctfs')) return [3 /*break*/, 14];
                        modal = this.modalService.openEmpty(ChangeTariffModalComponent);
                        return [4 /*yield*/, this.supportService.getCtfsDetail(siteId, site.domainUrl).toPromise()];
                    case 12:
                        details = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            invoiceNumber: details['invoiceNumber'],
                            dateToFormatted: details['dateToFormatted'],
                            tariffId: details['tariffId'],
                            currency: details['userCurrency'],
                            recurrentProfile: details['recurrentProfile'],
                        };
                        _a = data;
                        _b = 'tariffs';
                        return [4 /*yield*/, this.supportService.getTariffs(siteId).toPromise()];
                    case 13:
                        _a[_b] = _c.sent();
                        data['i18nTariffs'] = this.supportService.i18nTariffs;
                        this.modalService.fillData(modal, data).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 14:
                        if (!(action === 'rifs')) return [3 /*break*/, 16];
                        modal = this.modalService.openEmpty(RenewTariffModalComponent);
                        return [4 /*yield*/, this.supportService.getCtfsDetail(siteId, site.domainUrl).toPromise()];
                    case 15:
                        details = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            invoiceNumber: details['invoiceNumber'],
                            tariffId: details['tariffId'],
                            dateTo: this.datePipe.transform(details['dateTo'], 'YYYY-MM-DD'),
                            recurrentProfile: details['recurrentProfile'],
                            minCustomDaysCount: site._paidExpiration ? -site._paidExpiration : -999,
                        };
                        this.modalService.fillData(modal, data).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 16:
                        if (!(action === 'mits')) return [3 /*break*/, 18];
                        modal = this.modalService.openEmpty(TransferInvoiceModalComponent);
                        return [4 /*yield*/, this.supportService.getMitsDetail(siteId, site.domainUrl).toPromise()];
                    case 17:
                        details = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            tariffId: details['activeInvoice']['tariffId'],
                            dateTo: details['activeInvoice']['dateTo'],
                            invoiceNumber: details['activeInvoice']['invoiceNumber'],
                            sites: details['sites'],
                        };
                        this.modalService.fillData(modal, data).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 18:
                        if (!(action === 'rsai')) return [3 /*break*/, 20];
                        modal = this.modalService.openEmpty(RemoveInvoiceModalComponent);
                        return [4 /*yield*/, this.supportService.getRsaiDetail(siteId, site.domainUrl).toPromise()];
                    case 19:
                        details = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            tariffId: details['tariffId'],
                            dateTo: details['dateTo'],
                            invoiceNumber: details['invoiceNumber']
                        };
                        this.modalService.fillData(modal, data).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 20:
                        if (!(action === 'editCategory')) return [3 /*break*/, 23];
                        modal = this.modalService.openEmpty(EditSiteModalComponent, { size: 'hg' });
                        return [4 /*yield*/, this.supportService.checkSupportEdit(site._id).toPromise()];
                    case 21:
                        details = _c.sent();
                        return [4 /*yield*/, this.supportService.getSiteCategories().toPromise()];
                    case 22:
                        categories = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            categories: categories,
                            category: details['category'],
                            subject: details['subject'],
                            lastEditUser: details['lastEditUser'],
                            lastEditTime: details['lastEditTime'],
                            preview: details['preview'],
                        };
                        this.modalService.fillData(modal, data);
                        modal.componentInstance.calcSubcategories();
                        return [3 /*break*/, 54];
                    case 23:
                        if (!(action === 'siteBan')) return [3 /*break*/, 24];
                        this.modalService.open(RemoveSiteModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            userEmail: this.user.email
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 24:
                        if (!(action === 'csl')) return [3 /*break*/, 25];
                        this.modalService.open(ChangeLangModalComponent, {
                            siteId: site._id,
                            userId: this.user._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 25:
                        if (!(action === 'breakPublish')) return [3 /*break*/, 26];
                        this.modalService.open(BreakPublishModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl
                        });
                        return [3 /*break*/, 54];
                    case 26:
                        if (!(action === 'seoUber')) return [3 /*break*/, 27];
                        this.modalService.open(SeoUberModalComponent, {
                            title: site.domainUrl,
                            siteId: siteId,
                            action: (site.isSeoUber ? 'unset' : 'set')
                        });
                        return [3 /*break*/, 54];
                    case 27:
                        if (!(action === 'sf')) return [3 /*break*/, 28];
                        this.modalService.open(SetFreemiumSiteModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl,
                            inFreemiumMode: site.inFreemiumMode
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 28:
                        if (!(action === 'billingDetail')) return [3 /*break*/, 30];
                        modal = this.modalService.openEmpty(PaidDetailsComponent, { size: 'hg' });
                        return [4 /*yield*/, this.billingService.siteBilling.detail({ siteIds: [site._id] }).toPromise()];
                    case 29:
                        stats = (_c.sent()).stats;
                        data = {
                            title: site.domainUrl,
                            details: stats
                        };
                        this.modalService.fillData(modal, data);
                        return [3 /*break*/, 54];
                    case 30:
                        if (!(action === 'uberApply')) return [3 /*break*/, 31];
                        this.modalService.open(SetUberTariffModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl,
                            userId: this.user._id,
                        });
                        return [3 /*break*/, 54];
                    case 31:
                        if (!(action === 'showSiteLogs')) return [3 /*break*/, 33];
                        modal = this.modalService.openEmpty(LogsModalComponent, { size: 'hg' });
                        return [4 /*yield*/, this.supportService.getSiteLogs(site._id).toPromise()];
                    case 32:
                        stats = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            stats: stats
                        };
                        this.modalService.fillData(modal, data);
                        return [3 /*break*/, 54];
                    case 33:
                        if (!(action === 'siteAndUserActivity')) return [3 /*break*/, 34];
                        this.modalService.open(ConfirmComponent, {
                            title: site.domainUrl,
                            message: 'Вы уверены, что хотите выгрузить данные по сайту и его владельцу?'
                        }).result.then(function (isConfirmed) {
                            if (isConfirmed === true) {
                                window.location.href = _this.dp2.baseRoute + "/support/negotiator/sites/" + site._id + "/activity";
                            }
                        });
                        return [3 /*break*/, 54];
                    case 34:
                        if (!(action === 'fixWidgets')) return [3 /*break*/, 35];
                        this.modalService.open(FixWidgetsModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl
                        }).result.then(function (result) {
                            if (result && result !== 'cancel') {
                                _this.modalService.open(AlertComponent, {
                                    title: 'Результат',
                                    message: result
                                });
                            }
                        });
                        return [3 /*break*/, 54];
                    case 35:
                        if (!(action === 'disableRecurrentProfile')) return [3 /*break*/, 36];
                        this.modalService.open(DisableRecurrentModalComponent, {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            recurrentProfiles: site.recurrentProfiles,
                        }).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 36:
                        if (!(action === 'editRecurrent')) return [3 /*break*/, 39];
                        modal = this.modalService.openEmpty(EditRecurrentModalComponent);
                        return [4 /*yield*/, this.supportService.getCtfsDetail(siteId, site.domainUrl).toPromise()];
                    case 37:
                        details = _c.sent();
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            amount: 5,
                            userCurrency: '$',
                            rebillStartDate: this.datePipe.transform(details['dateTo'], 'YYYY-MM-DD'),
                            recurrentProfile: details.recurrentProfile,
                        };
                        return [4 /*yield*/, this.modalService.fillData(modal, data).result];
                    case 38:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 39:
                        if (!(action === 'siteRestore')) return [3 /*break*/, 41];
                        return [4 /*yield*/, this.modalService.open(RestoreSiteModalComponent, {
                                title: site.domainUrl,
                                siteId: siteId
                            }).result];
                    case 40:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 41:
                        if (!(action === 'setDivlyLabel')) return [3 /*break*/, 43];
                        return [4 /*yield*/, this.modalService.open(SetDivlyLabelModalComponent, {
                                title: site.domainUrl,
                                siteId: siteId,
                                action: (site.isUber ? 'unset' : 'set')
                            }).result];
                    case 42:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 43:
                        if (!(action === 'return_paid')) return [3 /*break*/, 45];
                        return [4 /*yield*/, this.siteService.getTransactionByQuery({ siteId: siteId }).toPromise()];
                    case 44:
                        transactions_1 = _c.sent();
                        modal = this.modalService.open(ReturnPaidComponent, {
                            title: site.domainUrl,
                            siteId: siteId,
                            transactions: transactions_1
                        });
                        form_1 = modal.componentInstance.form;
                        form_1.$beforeSubmit.subscribe(function (cb) { return __awaiter(_this, void 0, void 0, function () {
                            var data, transaction;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        data = form_1.value;
                                        transaction = transactions_1.find(function (c) { return c.transactionId == data.transactionId; });
                                        data.url = site.techUrl;
                                        data.tariffId = transaction.tariffId;
                                        data.tariffVariant = transaction.tariffVariant;
                                        data.recurrentProfile = site.recurrentProfile;
                                        return [4 /*yield*/, me.supportService.refound(siteId, data).toPromise()];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, me.applyFilter()];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/, cb()];
                                }
                            });
                        }); });
                        return [3 /*break*/, 54];
                    case 45:
                        if (!(action === 'showSiteHistory')) return [3 /*break*/, 47];
                        modal = this.modalService.openEmpty(SiteHistoryModal, { size: 'hg' });
                        return [4 /*yield*/, this.supportService.getSiteHistory(site._id).toPromise()];
                    case 46:
                        stats = (_c.sent()).stats;
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            stats: stats
                        };
                        this.modalService.fillData(modal, data);
                        return [3 /*break*/, 54];
                    case 47:
                        if (!(action === 'setMultilangClone')) return [3 /*break*/, 49];
                        modal = this.modalService.openEmpty(SetMultilangCloneModalComponent);
                        return [4 /*yield*/, this.supportService.getSiblings(site.userId).toPromise()];
                    case 48:
                        details = _c.sent();
                        siblings = details['siblings'];
                        siblings.unshift({ _id: '', url: '**Не Мультияз**' });
                        sites = siblings;
                        data = {
                            siteId: site._id,
                            title: site.domainUrl,
                            domainUrl: site.domainUrl,
                            multilangParentId: (!site.multilangParentId ? '' : site.multilangParentId),
                            siblings: sites,
                        };
                        this.modalService.fillData(modal, data).result.then(function (result) {
                            if (result === 'OK') {
                                me.applyFilter();
                            }
                        });
                        return [3 /*break*/, 54];
                    case 49:
                        if (!(action === 'siteClone')) return [3 /*break*/, 51];
                        return [4 /*yield*/, this.modalService.open(CloneSiteModalComponent, {
                                siteId: site._id,
                                userId: this.user._id,
                                url: site.domainUrl,
                            }).result];
                    case 50:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 51:
                        if (!(action === 'promopult')) return [3 /*break*/, 53];
                        return [4 /*yield*/, this.modalService.open(PromoputlModalComponent, {
                                title: 'Изменение баланса промопульта для сайта ' + site.domainUrl,
                                site: site,
                            }).result];
                    case 52:
                        result = _c.sent();
                        if (result === 'OK') {
                            me.applyFilter();
                        }
                        return [3 /*break*/, 54];
                    case 53:
                        if (action === 'siteFiles') {
                            this.modalService.open(SiteFilesModalComponent, {
                                title: site.domainUrl,
                                siteId: site._id,
                            }, { size: 'lg' });
                        }
                        _c.label = 54;
                    case 54: return [2 /*return*/];
                }
            });
        });
    };
    SupportComponent.prototype.saveNote = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.user.note.length > 0) {
                    this.supportService.saveNote(this.user._id, this.user.note).toPromise();
                }
                return [2 /*return*/];
            });
        });
    };
    SupportComponent.prototype.banSitesByList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.modalService.open(BanSitesByListModalComponent, {}).result.then(function () { });
                return [2 /*return*/];
            });
        });
    };
    SupportComponent.prototype.checkForDivly = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.modalService.open(CheckForDivlyModalComponent, {}).result.then(function () { });
                return [2 /*return*/];
            });
        });
    };
    SupportComponent.prototype.getUTMData = function (mark) {
        var utm = this.getUTMhash(mark);
        return this.utmList.reduce(function (arr, utmKey) {
            if (utm[utmKey]) {
                arr.push({ key: utmKey, utm: utm[utmKey] });
            }
            return arr;
        }, []);
    };
    SupportComponent.prototype.getSiteStatus = function (siteData) {
        var status = '';
        // желтый - фантоманые, недоделанные в визарде
        if (siteData.markForRemovalAt) {
            status = 'remove';
        }
        else if (siteData.status === -1) {
            status = 'before_constructor';
        }
        else if (siteData.status === 0) {
            status = 'switch_off';
        }
        else {
            // Если оплачен или включён на халяву
            if (siteData.paidType === 'paid' || siteData.paidType === 'trial' || siteData.inFreemiumMode) {
                // Если сайт опубликован
                if (siteData.datePublished) {
                    status = 'work';
                }
                else {
                    status = 'not published';
                }
            }
            else {
                status = 'expired';
            }
        }
        return status;
    };
    SupportComponent.prototype.getAge = function (dt) {
        var dtE = new Date().getTime();
        var dtS = new Date(dt).getTime();
        return parseInt(((dtE - dtS) / (24 * 3600 * 365.25 * 1000)).toString(), 10);
    };
    SupportComponent.prototype.showReRegInfo = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var users;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (user.countReReg === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.supportService.getReregList(user._id).toPromise()];
                    case 1:
                        users = (_a.sent()).users;
                        return [4 /*yield*/, this.modalService.open(UserReRegInfoModalComponent, {
                                title: 'Список аккаунтов-перерег',
                                currentUser: user,
                                users: users
                            }, { size: 'hg' }).result];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SupportComponent.prototype.changeHardboundStatus = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var me, comment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        event.target.blur();
                        event.preventDefault();
                        return [4 /*yield*/, me.modalService.open(PromptComponent, {
                                title: 'Комментарий!',
                                question: 'Введите комментарий, не меньше 10 символов',
                                message: ''
                            }).result];
                    case 1:
                        comment = _a.sent();
                        if (comment === 'cancel') {
                            me.user.hardbounce = !me.user.hardbounce;
                            return [2 /*return*/];
                        }
                        if (comment.length < 10) {
                            me.user.hardbounce = !me.user.hardbounce;
                            me.notificationService.info('Комментарий', 'Введите комментарий, не меньше 10 символов', { timeOut: 4000 });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, me.supportService.setUserHardbounce({
                                userId: me.user._id,
                                hardbounce: me.user.hardbounce,
                                comment: comment,
                            }).toPromise()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SupportComponent.prototype.onPageChange = function (page) {
        var _this = this;
        var me = this;
        me.filterSearch.sitePage = page;
        me.fillSites(this.filterSearch.sitePage, this.sitePageSize)
            .subscribe(function () {
            console.log('onPageChange', _this.filterSearch.sitePage, _this.sitePageSize);
        });
    };
    SupportComponent.prototype.fillSites = function (page, pageSize) {
        var me = this;
        if (me.$sitePagination) {
            me.$sitePagination.unsubscribe();
            me.$sitePagination = null;
        }
        me.sites = [];
        me.sitesInProgress = true;
        var offsetStart = (page - 1) * pageSize;
        var offsetEnd = offsetStart + pageSize;
        var siteIdList = me.searchResult.siteIdList.slice(offsetStart, offsetEnd);
        me.sitesOnPage = siteIdList.length;
        return from(siteIdList).pipe(concatMap(function (siteId) { return me.supportService.getSiteByID(siteId); }), tap(function () { return me.isCollapsedButtonsMore.push(true) && me.isCollapsedSiteMap.push(true); }), tap(function (site) {
            if (site) {
                site._source = me.supportService.cluster;
                me.sites.push(site);
            }
        }), toArray(), tap(function () { return me.sitesInProgress = false; }));
    };
    return SupportComponent;
}());
export { SupportComponent };
